import React from 'react';

type TemplateVariables =
  | Record<string, string | number | undefined>
  | undefined;

export function fillTemplate(
  template: string,
  variables?: TemplateVariables
): string {
  if (!variables) return template;

  if (!template) {
    console.warn(
      'fillTemplate: missing template string for provided variables',
      variables
    );
    return '-';
  }

  let missingKey: string | undefined;
  const result = template.replace(/\{(\w+)\}/g, (_, key) => {
    if (!missingKey && variables[key] === undefined) missingKey = key;
    return String(variables[key]);
  });
  if (missingKey) {
    console.warn(
      `fillTemplate: missing variable "${missingKey}" for template "${template}"`
    );
    return '-';
  }

  return result;
}

export function interpolateTemplate(
  template: string,
  variables?: TemplateVariables,
  Wrapper?: React.ComponentType<{ children: React.ReactNode }>
): React.ReactNode {
  if (!template || !variables || !Wrapper)
    return fillTemplate(template, variables);

  return template.split(/(\{\w+\})/g).map((chunk, index) => {
    const key = chunk.match(/^\{(\w+)\}$/)?.[1];
    const value = key && variables[key];
    return value !== undefined ? <Wrapper key={index}>{value}</Wrapper> : chunk;
  });
}
